define([], function () {
    function isNotNullOrUndefined(item) {
        return typeof item !== "undefined" && item !== null;
    }

    function shouldRunCcfTrackingHandler(item) {
        return isNotNullOrUndefined(item) && isNotNullOrUndefined(item.ccf_scope);
    }

    function isOpenUrlInNewTab(targetVal) {
        return isNotNullOrUndefined(targetVal) && targetVal === "_blank";
    }

    function hasNavigation(hrefVal) {
        return isNotNullOrUndefined(hrefVal) && hrefVal.length > 0;
    }

    function resumeNavigation(item) {
        const url = item.href;
        if (isOpenUrlInNewTab(item.target)) {
            window.open(url, "_blank");
        } else {
            window.location.href = url;
        }
    }

    function hasHoverState() {
        if (matchMedia('(hover:hover)').matches) {
            return true;
        }
        return false;
    }

    return {
        isNotNullOrUndefined: isNotNullOrUndefined,
        shouldRunCcfTrackingHandler: shouldRunCcfTrackingHandler,
        isOpenUrlInNewTab: isOpenUrlInNewTab,
        hasNavigation: hasNavigation,
        resumeNavigation: resumeNavigation,
        hasHoverState: hasHoverState
    };
})